import { render, staticRenderFns } from "./ModalSlide.vue?vue&type=template&id=19827852&scoped=true&"
import script from "./ModalSlide.vue?vue&type=script&lang=js&"
export * from "./ModalSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19827852",
  null
  
)

export default component.exports